import {
    Box,
    TextField
} from '@mui/material';
import { styled } from '@mui/material/styles';

const Content = styled('section')`
    display: flex;
    padding: 1%;
    gap: 8px;
    flex-wrap: wrap;
`;

const InfoVenda = styled('section')`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 10px;

    p {
        width: 100%;
    }
`;

const InfoVendaLinha = styled('div')`
    display: flex;
    width: 100%;
`;

const InfoVendaLabel = styled('span')`
    width: 200px;
`;

const InfoVendaValor = styled('span')`
    flex: 1;
`

const InfoNotasFiscais = styled('section')`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    
`;

const Campo = styled(TextField)`
    margin: 1vh 0 1vh 0;
`;

export { Content, Campo, InfoVenda, InfoVendaLinha, InfoVendaLabel, InfoVendaValor };